import React, { useState } from 'react';
import { Link } from 'gatsby';
import animateScrollTo from 'animated-scroll-to';
import { useSwipeable } from 'react-swipeable'
import { css } from '../../page-helpers/aphrodite-export';

import Header from '../../templates/mobile/header';
import { MobileStyles } from '../../styles/index';
import BouncingArrow from '../../templates/mobile/bouncing-arrow';

import {
    s1img, s1icbg, s1_1ic, s1_2ic, s1_3ic, s1_4ic, s2img, s2icbg, s2_1ic, s2_2ic, s2_3ic,
    s3img, s3icbg, s3_1ic, s3_2ic, s3_3ic, s4img, s4icbg, s4_1ic, s4_2ic, s4_3ic, s4_4ic, s5img,
    s5icbg, s5_1ic, s5_2ic, s5_3ic, s6img, s6icbg, s6_1ic, s6_2ic, s6_3ic, s6_4ic, s7img, s7icbg,
    s7_1ic, s7_2ic, s7_3ic, s8img, s8icbg, s8_1ic, s8_2ic, s8_3ic, s9img, s9icbg, s9_1ic, s9_2ic,
    s9_3ic, s9_4ic
} from '../../page-helpers/mobile-images';

import BannerImg from '../../assets/images/mobile_home_banner.png';

const ScreenNos = 10;

// {props.nextScreen ? <div className="center-con" onClick={props.nextScreen}>
//                     <div className="round">
//                         <div className="cta">
//                             <span className="arrow primera next "></span>
//                             <span className="arrow segunda next "></span>
//                         </div>
//                     </div>
//                 </div> : <div className="center-con" onClick={props.gotoTop}>
//                     <div className="round">
//                         <div className="cta">
//                             <span className="arrow primera prev"></span>
//                             <span className="arrow segunda prev"></span>
//                         </div>
//                     </div>
//                 </div>}

const IndexScreen = (props) => {
    return (
        <div>
            <div className={css(MobileStyles.screenImageSec)}>
                <img src={props.images.simg} className={css(MobileStyles.screenImageSecImg)}
                    width={props.mainImgW ? props.mainImgW : '100%'}
                    height={props.mainImgH ? props.mainImgH : 'auto'} />

                <div className={css(MobileStyles.screenTxtSec)}>
                    <div className={css(MobileStyles.screenTxtSecHeader)}>
                        {props.headerTxt}
                    </div>
                    <div className={css(MobileStyles.screenTxtSecInfo)}>
                        {props.txtInfo}
                    </div>
                </div>
            </div>
            <div className={css(MobileStyles.screenIconsSec)} style={{
                paddingLeft: props.icnsSecPaddingLeft + '%',
                width: (100 - props.icnsSecPaddingLeft) + '%'
            }}>
                <div className={css(MobileStyles.screenIconsSecCircle)}>
                    <img src={props.images.s_1ic.img} className={css(MobileStyles.screenIconsSecCircleImg)} />
                    <div className={css(MobileStyles.screenIconsSecCircleTxt)}>{props.images.s_1ic.txt}</div>
                </div>
                <div className={css(MobileStyles.screenIconsSecCircle)}>
                    <img src={props.images.s_2ic.img} className={css(MobileStyles.screenIconsSecCircleImg)} />
                    <div className={css(MobileStyles.screenIconsSecCircleTxt)}>{props.images.s_2ic.txt}</div>
                </div>
                {props.images.s_3ic ?
                    <div className={css(MobileStyles.screenIconsSecCircle)}>
                        <img src={props.images.s_3ic.img} className={css(MobileStyles.screenIconsSecCircleImg)} />
                        <div className={css(MobileStyles.screenIconsSecCircleTxt)}>{props.images.s_3ic.txt}</div>
                    </div>
                    : null}
                {props.images.s_4ic ?
                    <div className={css(MobileStyles.screenIconsSecCircle)}>
                        <img src={props.images.s_4ic.img} className={css(MobileStyles.screenIconsSecCircleImg)} />
                        <div className={css(MobileStyles.screenIconsSecCircleTxt)}>{props.images.s_4ic.txt}</div>
                    </div>
                    : null}
                <div className={css(MobileStyles.screenIconsSecImg)}>
                    <img src={(props.images.sicbg && props.images.sicbg.img) ? props.images.sicbg.img : props.images.sicbg}
                        alt={props.images.sicbg && props.images.sicbg.alttxt}
                        style={{
                            position: 'absolute',
                            width: props.icnsImg.width + '%',
                            height: props.icnsImg.height,
                            right: props.icnsImg.right + '%',
                            bottom: props.icnsImg.bottom + '%'
                        }}
                    />
                    <div style={{
                        position: 'absolute',
                        color: 'white',
                        fontSize: '16px',
                        right: (props.icnsImg.width + props.icnsImg.right + 2) + '%',
                        bottom: '96%'
                    }}>{props.icnsImgTxt}</div>
                </div>
            </div>
            <div className={css(MobileStyles.bottomCallToActionBar)}>
                <a href="tel:+91-9392905179">
                    <div className={css(MobileStyles.bottomCallToActionBarActioItem)}>
                        <span className={css(MobileStyles.bottomCallToActionBarActioItemtxt)}>
                            Talk to us
                        </span>
                    </div>
                </a>
                <div className={css(MobileStyles.bottomCallToActionBarActioItemSep)}>
                    {/*<i className={css(MobileStyles.bottomCallToActionArrow, MobileStyles.bottomCallToActionArrowDown)}></i>*/}
                </div>
                <Link to='/scheduledemo'>
                    <div className={css(MobileStyles.bottomCallToActionBarActioItem)}>
                        <span className={css(MobileStyles.bottomCallToActionBarActioItemtxt)}>
                            Schedule Demo
                        </span>
                    </div>
                </Link>
            </div>
        </div>
    );
}

const SwipeDelta = 20;

var SwipeConfig = { delta: SwipeDelta, preventDefaultTouchmoveEvent: false };

const IndexScreenCtn = () => {
    let [screenCounter, setScreenCounter] = useState(1);
    let screenIndex = 1;
    let scrollInProgress = false;

    const onSwipe = (swipeEvent, clickMove, index) => {
        let nativeEvent = swipeEvent.event;

        if (nativeEvent && nativeEvent.cancelable) {
            nativeEvent.preventDefault();
        }

        if (!scrollInProgress) {
            let scrollCtn = document.getElementById('viewport');

            if ((Math.abs(swipeEvent.deltaY) > 50) || clickMove) {
                scrollInProgress = true;

                if (clickMove) {
                    if (index) {
                        screenIndex = index;
                    } else {
                        screenIndex = screenIndex + 1;
                    }
                } else {
                    if (swipeEvent.dir === 'Up') {
                        screenIndex = screenIndex + 1;
                    } else {
                        screenIndex = screenIndex - 1;
                    }
                }

                if (screenIndex > ScreenNos) {
                    screenIndex = ScreenNos;
                } else if (screenIndex < 1) {
                    screenIndex = 1;
                }
            }

            animateScrollTo(scrollCtn.children[screenIndex - 1].offsetTop, {
                speed: 50,
                minDuration: 500,
                maxDuration: 500,
                element: scrollCtn,
                offset: 0,
                cancelOnUserAction: false,
                horizontal: false,
                onComplete: function () {
                    scrollInProgress = false;

                    console.log('This is screen index', screenIndex);
                }
            });
        }
    }

    var SwipeHandlers = useSwipeable({
        onSwiped: (eventData) => {
            console.log(eventData);

            onSwipe(eventData);
        },

        ...SwipeConfig
    });

    const nextScreen = function () {
        onSwipe({}, true);
    };

    const gotoTop = function () {
        onSwipe({}, true, 1);
    };

    console.log('this is before rendering', screenCounter);

    return (
        <div id="viewport" className={css(MobileStyles.screenViewPort)} {...SwipeHandlers}>
            <div className={css(MobileStyles.screenCtn)}>
                <img src={BannerImg} className={css(MobileStyles.bannerImg)} />
                <div className={css(MobileStyles.bannerTxt)}>
                    Meet India's finest smart home automation company
                </div>
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn)}>
                <IndexScreen
                    images={{
                        simg: s1img,
                        sicbg: s1icbg,
                        s_1ic: { img: s1_1ic, txt: 'AC Control' },
                        s_2ic: { img: s1_2ic, txt: 'Fan Control' },
                        s_3ic: { img: s1_3ic, txt: 'Curtain Control' },
                        s_4ic: { img: s1_4ic, txt: 'Light Control' },
                    }}
                    icnsSecPaddingLeft={2}
                    headerTxt={<span>control from here,<br />there, everywhere</span>}
                    txtInfo={<span>one app all controls.</span>}
                    icnsImg={{
                        width: 16,
                        height: 'auto',
                        bottom: 80,
                        right: 6
                    }}
                    icnsImgTxt={'smart control'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorPurple)}>
                <IndexScreen
                    images={{
                        simg: s2img,
                        sicbg: s2icbg,
                        s_1ic: { img: s2_1ic, txt: 'Simple retrofit' },
                        s_2ic: { img: s2_2ic, txt: 'No extra wiring' },
                        s_3ic: { img: s2_3ic, txt: 'Flicker free' }
                    }}
                    icnsSecPaddingLeft={15}
                    headerTxt={<span>wirefree installation,<br />worry-free transformation.</span>}
                    txtInfo={<span>any home is now a<br />smart home.</span>}
                    icnsImg={{
                        width: 36,
                        height: 'auto',
                        bottom: 80,
                        right: 2
                    }}
                    icnsImgTxt={'smart switch'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s3img,
                        sicbg: s3icbg,
                        s_1ic: { img: s3_1ic, txt: 'Movie' },
                        s_2ic: { img: s3_2ic, txt: 'Relax' },
                        s_3ic: { img: s3_3ic, txt: 'Party' }
                    }}
                    icnsSecPaddingLeft={15}
                    headerTxt={<span>change in mood,<br />change the mood.</span>}
                    txtInfo={<span>one switch, many moods.</span>}
                    icnsImg={{
                        width: 30,
                        height: 'auto',
                        bottom: 80,
                        right: 2
                    }}
                    icnsImgTxt={'smart scenes'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s4img,
                        sicbg: s4icbg,
                        s_1ic: { img: s4_1ic, txt: 'Preset Timers' },
                        s_2ic: { img: s4_2ic, txt: 'Custom Timers' },
                        s_3ic: { img: s4_3ic, txt: 'Device Schedule' },
                        s_4ic: { img: s4_4ic, txt: 'Scene Schedule' }
                    }}
                    icnsSecPaddingLeft={2}
                    headerTxt={<span>schedule now.<br />automate forever.</span>}
                    txtInfo={<span>its your home,<br />create your rules</span>}
                    icnsImg={{
                        width: 22,
                        height: 'auto',
                        bottom: 80,
                        right: 2
                    }}
                    icnsImgTxt={'smart schedule'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s5img,
                        sicbg: s5icbg,
                        s_1ic: { img: s5_1ic, txt: 'Echo' },
                        s_2ic: { img: s5_2ic, txt: 'Google Home' },
                        s_3ic: { img: s5_3ic, txt: 'Talk to execute' }
                    }}
                    icnsSecPaddingLeft={15}
                    headerTxt={<span>just say it, your home<br />will just do it!</span>}
                    txtInfo={<span>your voice, our command</span>}
                    icnsImg={{
                        width: 25,
                        height: 'auto',
                        bottom: 80,
                        right: 4
                    }}
                    icnsImgTxt={'smart voice'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s6img,
                        sicbg: s6icbg,
                        s_1ic: { img: s6_1ic, txt: 'Personalised moods' },
                        s_2ic: { img: s6_2ic, txt: 'Control from anywhere' },
                        s_3ic: { img: s6_3ic, txt: 'Super quiet' },
                        s_4ic: { img: s6_4ic, txt: 'Multi control' }
                    }}
                    icnsSecPaddingLeft={2}
                    headerTxt={<span>smart home<br />smarter curtains</span>}
                    txtInfo={<span>drape in the new wave.</span>}
                    icnsImg={{
                        width: 50,
                        height: 'auto',
                        bottom: 80,
                        right: 0
                    }}
                    icnsImgTxt={'smart blinds'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s7img,
                        sicbg: s7icbg,
                        s_1ic: { img: s7_1ic, txt: 'Multi functional' },
                        s_2ic: { img: s7_2ic, txt: '360 degree range' },
                        s_3ic: { img: s7_3ic, txt: 'Easy to operate' },
                    }}
                    icnsSecPaddingLeft={15}
                    headerTxt={<span>the master remote<br />every home needs</span>}
                    txtInfo={<span>single point of control.</span>}
                    icnsImg={{
                        width: 40,
                        height: 'auto',
                        bottom: 85,
                        right: 2
                    }}
                    icnsImgTxt={'smart remote'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s8img,
                        sicbg: s8icbg,
                        s_1ic: { img: s8_1ic, txt: 'Integrate with scenes' },
                        s_2ic: { img: s8_2ic, txt: 'color patterns' },
                        s_3ic: { img: s8_3ic, txt: 'Range of light effects' }
                    }}
                    icnsSecPaddingLeft={15}
                    headerTxt={<span>go beyond the<br />yellows and whites</span>}
                    txtInfo={<span>an ambience for every colour.</span>}
                    icnsImg={{
                        width: 22,
                        height: 'auto',
                        bottom: 80,
                        right: 2
                    }}
                    icnsImgTxt={'smart colours'}
                    nextScreen={nextScreen}
                />
                <BouncingArrow arrowDown={true} onClickAction={function () { nextScreen() }} />
            </div>

            <div className={css(MobileStyles.screenCtn,
                MobileStyles.colorBlue)}>
                <IndexScreen
                    images={{
                        simg: s9img,
                        sicbg: { img: s9icbg, alttxt: 'motion sensors' },
                        s_1ic: { img: s9_1ic, txt: 'Gas' },
                        s_2ic: { img: s9_2ic, txt: 'Smoke' },
                        s_3ic: { img: s9_3ic, txt: 'Door window' },
                        s_4ic: { img: s9_4ic, txt: 'Motion sensor' }
                    }}
                    icnsSecPaddingLeft={2}
                    headerTxt={<span>many sensors, <br />maximum benefit</span>}
                    txtInfo={<span>give your home<br />that extra sense</span>}
                    icnsImg={{
                        width: 45,
                        height: 'auto',
                        bottom: 80,
                        right: 2
                    }}
                    icnsImgTxt={'smart sense'}
                    gotoTop={gotoTop}
                />
                <BouncingArrow arrowDown={false} onClickAction={function () { gotoTop() }} />
            </div>
        </div>
    );
}

export default () => {
    return (
        <div>
            <Header />
            <IndexScreenCtn />
        </div>
    );
}
